import React, { useContext, useState } from "react";
import { Stack } from "@mui/material";
import {
  StyledButton,
  StyledMiniButton,
  StyledMiniHeader,
  StyledContainer,
  StyledIcon,
  StyledHoverContainer
} from "./SideNavBar.styles";
import { GlobalContext } from "context/Provider";
import { useTranslation } from "react-i18next";
import { GROUP_KEY_MAP } from "helpers/variables";
import { useLocation } from "react-router-dom";

export default function SideNavBar() {
  const { t } = useTranslation();
  const location = useLocation();
  const view = location.pathname.split("/")[2];
  const subview = location.pathname.split("/")[3];
  const showSubmenu = view === "history";
  const { member, config, settings } = useContext(GlobalContext);
  const settingsPath = settings?.member?.data?.system?.settings?.historyOptions;
  const defaultSettings = settings?.default?.data?.system?.settings as
    | Record<string, Record<string, boolean>>
    | undefined;

  const isTabVisible = (shortKey: string) => {
    const defaultGroup = defaultSettings?.[shortKey];

    const defaultEnabled = defaultGroup
      ? Object.values(defaultGroup).some(Boolean)
      : false;

    const userOption = settingsPath?.[GROUP_KEY_MAP[shortKey]];

    return defaultEnabled && userOption !== false;
  };

  const HoverList = () => {
    return (
      <StyledHoverContainer>
        <Stack>
          <StyledMiniHeader>{t("u-history")}</StyledMiniHeader>
          <StyledMiniButton
            //@ts-ignore
            selectedButton={subview === "timeline"}
            to={`/patient/history/timeline/${member?.current.id}`}
          >
            {t("u-timeline")}
          </StyledMiniButton>
          {isTabVisible("bp") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "bloodpressure"}
              to={`/patient/history/bloodpressure/list/${member?.current.id}`}
            >
              {t("u-blood-pressure")}
            </StyledMiniButton>
          )}
          {isTabVisible("bgl") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "bloodglucose"}
              to={`/patient/history/bloodglucose/list/${member?.current.id}`}
            >
              {t("u-blood-glucose")}
            </StyledMiniButton>
          )}
          {isTabVisible("hrt") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "heartrate"}
              to={`/patient/history/heartrate/list/${member?.current.id}`}
            >
              {t("u-heart-rate")}
            </StyledMiniButton>
          )}
          {isTabVisible("spo2") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "oxygensaturation"}
              to={`/patient/history/oxygensaturation/list/${member?.current.id}`}
            >
              {t("u-oxygen-saturation")}
            </StyledMiniButton>
          )}
          {isTabVisible("spir") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "spirometry"}
              to={`/patient/history/spirometry/list/${member?.current.id}`}
            >
              Spirometry
            </StyledMiniButton>
          )}
          {isTabVisible("temp") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "temperature"}
              to={`/patient/history/temperature/list/${member?.current.id}`}
            >
              {t("u-temperature")}
            </StyledMiniButton>
          )}
          {isTabVisible("wt") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "weight"}
              to={`/patient/history/weight/list/${member?.current.id}`}
            >
              {t("u-weight")}
            </StyledMiniButton>
          )}
          {isTabVisible("activity") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "activity"}
              to={`/patient/history/activity/list/${member?.current.id}`}
            >
              {t("u-activity")}
            </StyledMiniButton>
          )}
          {isTabVisible("sleep") && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "sleep"}
              to={`/patient/history/sleep/list/${member?.current.id}`}
            >
              {t("u-sleep")}
            </StyledMiniButton>
          )}
          {settingsPath?.respirationRate && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "respirationrate"}
              to={`/patient/history/respirationrate/list/${member?.current.id}`}
            >
              {t("u-respiration-rate")}
            </StyledMiniButton>
          )}
          {settingsPath?.memberNotes && (
            <StyledMiniButton
              //@ts-ignore
              selectedButton={subview === "membernote"}
              to={`/patient/history/membernote/list/${member?.current.id}`}
            >
              {t("u-member-notes")}
            </StyledMiniButton>
          )}
        </Stack>
      </StyledHoverContainer>
    );
  };

  const showText = (text: string) => {
    return !showSubmenu ? text : "";
  };
  return (
    <StyledContainer>
      {showSubmenu ? <HoverList /> : ""}
      <Stack>
        <StyledButton
          //@ts-ignore
          selectedButton={view === "profile"}
          to={`/patient/profile/${member?.current.id}`}
        >
          <StyledIcon>person</StyledIcon>
          {showText(t("u-profile"))}
        </StyledButton>
        <StyledButton
          //@ts-ignore
          selectedButton={view === "details"}
          to={`/patient/details/${member?.current.id}`}
        >
          <StyledIcon>account_box</StyledIcon>
          {showText(t("u-management-details"))}
        </StyledButton>
        {config?.basicOptions.notes ? (
          <StyledButton
            //@ts-ignore
            selectedButton={view === "notes"}
            to={`/patient/notes/${member?.current.id}`}
          >
            <StyledIcon>menu_book</StyledIcon>
            {showText(t("u-staff-notes"))}
          </StyledButton>
        ) : (
          ""
        )}
        <StyledButton
          //@ts-ignore
          selectedButton={view === "vitals"}
          to={`/patient/vitals/${member?.current.id}`}
        >
          <StyledIcon>home</StyledIcon>
          {showText(t("u-vitals"))}
        </StyledButton>
        <StyledButton
          //@ts-ignore
          selectedButton={view === "history"}
          to={`/patient/history/timeline/${member?.current.id}`}
        >
          <StyledIcon>list_alt</StyledIcon>
          {showText(t("u-history"))}
        </StyledButton>
        {config?.basicOptions.surveys ? (
          <StyledButton
            //@ts-ignore
            selectedButton={view === "surveys"}
            to={`/patient/surveys/${member?.current.id}`}
          >
            <StyledIcon>poll</StyledIcon>
            {showText("Surveys")}
          </StyledButton>
        ) : (
          ""
        )}
        <StyledButton
          //@ts-ignore
          selectedButton={view === "export"}
          to={`/patient/export/${member?.current.id}`}
        >
          <StyledIcon>open_in_new</StyledIcon>
          {showText(t("u-export"))}
        </StyledButton>
        {/* <StyledButton to={`/patient/notifications/${member?.current.id}`} onClick={()=>{setShowSubmenu(false)}}><StyledIcon>notifications</StyledIcon>{showText(t('u-notifications'))}</StyledButton> */}
        <StyledButton
          //@ts-ignore
          selectedButton={view === "encounters"}
          to={`/patient/encounters/${member?.current.id}`}
        >
          <StyledIcon>contact_page</StyledIcon>
          {showText(t("u-encounters"))}
        </StyledButton>
        {/* <StyledButton to={`/patient/monitoring/${member?.current.id}`} onClick={()=>{setShowSubmenu(false)}}><StyledIcon>contact_page</StyledIcon>{showText(t('u-monitoring'))}</StyledButton> */}
        <StyledButton
          //@ts-ignore
          selectedButton={view === "devices"}
          to={`/patient/devices/${member?.current.id}`}
        >
          <StyledIcon>mobile_friendly</StyledIcon>
          {showText("Devices")}
        </StyledButton>
        <StyledButton
          to={window.location.pathname}
          onClick={() => {
            window.open("https://life365inc.vsee.me/providers/login", "_black");
          }}
        >
          <StyledIcon>video_camera_front_icon</StyledIcon>
          {showText("Video Chat")}
        </StyledButton>
        {config?.basicOptions.messaging ? (
          <StyledButton
            //@ts-ignore
            selectedButton={view === "messages"}
            to={`/patient/messaging/${member?.current.id}`}
          >
            <StyledIcon>message</StyledIcon>
            {showText("Messaging")}
          </StyledButton>
        ) : (
          ""
        )}
        <StyledButton
          //@ts-ignore
          selectedButton={view === "options"}
          to={`/patient/options/${member?.current.id}`}
        >
          <StyledIcon>settings</StyledIcon>
          {showText(t("u-display-options"))}
        </StyledButton>
      </Stack>
    </StyledContainer>
  );
}
